export default class Appointment {
  constructor() {
    // In the assessment-without-video flow there is no player, so
    // appointment_player.player is null. Guard the pause() calls; otherwise the
    // TypeError thrown here halts create_success.js.erb before it re-runs
    // `new Observation()`, leaving the Official->Category cascade unbound.
    $("#flush-headingOne").on("click", () => {
      window.appointment_player?.player?.pause();
    });

    $("#flush-headingFour").on("click", () => {
      window.appointment_player?.player?.pause();
    });

    $("#flush-headingFive").on("click", () => {
      window.appointment_player?.player?.pause();
    });
  }
}
